<template>
  <div id="page-container">
    <div id ='main-container' :style="{width:width,height:height}">
      <div id="fix-top" :class="pageColor">
        <div @click="backhome" id = "homebutton">
          <div id="backSymbol">&lsaquo;&lsaquo;</div>
          <div id="backText">
            <p>返回首页</p>
            <p id="backTextEN">CONTENTS</p>
          </div>
        </div>
      </div>
      <div id="content-body" :style="{height:contentheight}">
        <div class="bodySide" id="body-left">
          <div id="partName">
            <p id="partNameCN-text">{{partName}}</p>
            <p id="partNameEN-text">{{partNameEN}}</p>
          </div>
        </div>
        <div id="bodyMiddle">
          <viewer :images="images" id="imageGallery">
            <div class="imgPreview" v-for="(item,index) in images" :key="item.index" :id="imgID('imgPreview', index)" >
              <img class="imgSmall"
              :id="imgID('imgSmall', index)"
              :src="item.url72"
              :data-source="item.url150">
            </div>
          </viewer>
        </div>
        <div class="bodySide" id="body-right">
          <div id="partNum">{{partNum}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import { contents } from '../assets/contents'
import { picsSmall, picsLarge } from '../assets/imgUrl'

// 屏蔽错误提示
// window.onerror=function(){return true;}

export default {
  data: function () {
    return {
      isM: this.isMobile,
      isOri: false,
      pageHeight: window.innerHeight,
      pageWidth: window.innerWidth,
      height: '',
      width: '',
      contentheight: (window.innerHeight - 50) + 'px',
      mapObj: null,
      mapExtent: null,
      imageBounds: null,
      imageBoundsLong: null,
      imageLayer: null,
      pre: '',
      count: 0,
      pageNum: 0,
      figNum: 0,
      pageColor: 'pageColor' + this.part,
      pageTextColor: 'pageTextColor' + this.part,
      lastPick: 'page0',
      partName: '',
      partNameEN: '',
      partNum: '',
      part_imgCounts: '',
      images: []
    }
  },
  props: [
    'part',
    'chapter',
    'section',
    'fig',
    'alias'
  ],
  methods: {
    imgID: function (name, index) {
      return name + index
    },
    backhome: function () {
      this.$emit('back')
    }
  },
  created () {
    const that = this
    // window.sliderSwitch = that.sliderSwitch
    const width = document.documentElement.clientWidth
    const height = document.documentElement.clientHeight
    that.width = width + 'px'
    that.height = height + 'px'
    that.contentheight = (height - 50) + 'px'
    if (width < 1100) {
      that.width = '1100px'
      document.body.style.overflowX = 'auto'
    }
  },
  mounted () {
    const that = this
    var pianhao = ['', 'Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ', '附']
    that.partNum = pianhao[parseInt(that.part - 1)]
    that.partName = contents[that.part - 1].name
    that.partNameEN = contents[that.part - 1].nameEN

    var imgCounts = picsSmall[`par${that.part}`].length
    that.part_imgCounts = imgCounts
    var imagesurl = []
    for (let img = 0; img < imgCounts; img++) {
      var imgurl = {}
      imgurl.url72 = require('@/assets' + picsSmall[`par${that.part}`][img])
      imgurl.url150 = require('@/assets' + picsLarge[`par${that.part}`][img])
      imgurl.index = img + 1
      imagesurl[img] = imgurl
    }
    that.images = imagesurl

    // 手动延时以下，确保DOM加载完成
    setTimeout(() => {
      if (that.alias != 'par') {
        document.getElementById(`imgSmall${that.fig - 1}`).click()
        document.oncontextmenu = function () { return false }
      }
    }, 150)
    window.addEventListener('resize', function () {
      const h = document.documentElement.clientHeight
      const w = document.documentElement.clientWidth
      that.width = w + 'px'
      that.height = h + 'px'
      that.contentheight = (h - 50) + 'px'
      if (w < 1100) {
        that.width = '1100px'
        document.body.style.overflowX = 'auto'
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- 由于使用了innerHTML，需要去掉scope -->
<style>
#main-container{
  background-color: rgb(241, 241, 241);
  overflow-y: hidden;
}
#fix-top{
  height: 50px;
  width: 100%;
}
#homebutton{
  background-color: #1F4263;
  height: 50px;
  width: 120px;
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  color: rgb(221, 221, 221);
}
#backSymbol{
  font-weight: bold;
  font-size: 24px;
  width:20px;
  line-height: 20px;
}
#backText{
  width:86px;
  line-height: 14px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: bolder;
  font-size: 14px;
  text-shadow: #1F4263 1px 0 0, #1F4263 0 1px 0, #1F4263 -1px 0 0, #1F4263 0 -1px 0;
}
#backTextEN{
  font-size: 9px;
  letter-spacing: 0.2px;
}
#content-body{
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-grow: 1;
  justify-content: space-between;
  align-items: stretch;
  background-color: rgb(241, 241, 241);
}
.bodySide{
  width: 60px;
  height: inherit;
}
#partName{
  margin-left: 20px;
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: inherit;
}
#partNameCN-text{
  margin-top: 20px;
  writing-mode: vertical-lr;
  writing-mode: tb-lr;
  line-height: 1.2em;
  letter-spacing: 3px;
  font-family: 'Noto Sans SC';
  font-weight: 700;
  font-size: 18pt;
  color: rgb(163, 163, 163);
  margin-right: 5px;
}
#partNameEN-text{
  margin-top: 20px;
  writing-mode: vertical-rl;
  writing-mode: tb-rl;
  line-height: 1em;
  letter-spacing: 0px;
  font-family: 'Noto Sans SC';
  font-weight: 500;
  font-size: 12pt;
  color: rgb(175, 175, 175);
}
#body-right{
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
}
#partNum{
  width: 90px;
  height: 90px;
  writing-mode: vertical-lr;
  writing-mode: tb-lr;
  line-height: 90px;
  letter-spacing: 2px;
  font-family: 'Noto Sans SC';
  font-weight: 700;
  font-size: 90px;
  color: rgba(80, 80, 80, 0.2);
  margin-right: 18px;
  margin-bottom: 20px;
  font-family: "Times New Roman",Georgia,Serif;
}
#bodyMiddle{
  width: 860px;
  min-width: 860px;
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
}
#bodyMiddle::-webkit-scrollbar{
  display:none;
}
#imageGallery{
  margin: 15px 20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
}
.imgPreview{
  width: 162px;
  height: 162px;
  border-left: 1px solid rgb(240, 240, 240);
  border-right: 1px solid rgb(240, 240, 240);
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgSmall{
  width: 85%;
  margin: auto 0;
  opacity: 1;
}
.imgSmall:hover{
  background-color: rgb(0, 0, 0);
  opacity: 0.2;
}
/* #page-container::-webkit-scrollbar {
    width: 0;
} */

</style>
